import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import logger from '../../../services/logger';

import { User } from './auth.types';

export interface AuthState {
  initialized: boolean;
  user: User | null;
}
const initialState: AuthState = {
  initialized: false,
  user: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthInitialized: (state, action: PayloadAction<void>) => {
      logger.debug('Updating auth state to initialized.', action);
      state.initialized = true;
    },
    login: (state, action: PayloadAction<User>) => {
      logger.debug('Login action.', { state, action });
      state.user = { ...action.payload };
      state.initialized = true;
    },
    logout: (state) => {
      logger.debug('Logout action.', { state });
      state.user = null;
      state.initialized = true;
    },
  },
});
export const {
  setAuthInitialized: setAuthInitializedAction,
  login: loginAction,
  logout: logoutAction,
} = authSlice.actions;

export default authSlice.reducer;
